import { IFrameworkStrings } from "framework/localization/IFrameworkStrings";
import { nlFrameworkStrings } from "framework/localization/nlFrameworkStrings";
import { LanguageOption } from "./LanguageOption";

export const localizationRecord: Record<LanguageOption, IFrameworkStrings> = {
  nl: nlFrameworkStrings,
}

